export const optionDrivingMarketLimit = 5;
export var EOptionDrivingMarketSectionType;
(function (EOptionDrivingMarketSectionType) {
    EOptionDrivingMarketSectionType["HIGHEST_OI"] = "highestOI";
    EOptionDrivingMarketSectionType["HIGHEST_OI_GAINER"] = "highestOIGainer";
    EOptionDrivingMarketSectionType["HIGHEST_OI_LOSER"] = "highestOILoser";
    EOptionDrivingMarketSectionType["HIGHEST_VOLUME"] = "highestVolume";
})(EOptionDrivingMarketSectionType || (EOptionDrivingMarketSectionType = {}));
export var EPeriod;
(function (EPeriod) {
    EPeriod["ONE_DAY"] = "1D";
    EPeriod["ONE_WEEK"] = "1WK";
    EPeriod["ONE_MONTH"] = "1MN";
})(EPeriod || (EPeriod = {}));
export var ECallPutTabs;
(function (ECallPutTabs) {
    ECallPutTabs["CALL"] = "callMessage";
    ECallPutTabs["PUT"] = "putMessage";
})(ECallPutTabs || (ECallPutTabs = {}));
